import { render } from "./IosManualPage.vue?vue&type=template&id=4c03f69c&scoped=true"
import script from "./IosManualPage.vue?vue&type=script&lang=js"
export * from "./IosManualPage.vue?vue&type=script&lang=js"

import "./IosManualPage.vue?vue&type=style&index=0&id=4c03f69c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c03f69c"]])

export default __exports__